import React, { useState } from 'react';
import { Container, Row, Col, Image, Card } from 'react-bootstrap';
import { dateFormate, indianTimeZone, removeKeysFromObj } from '../../../utils/helper';
import MessageTypeList from './messageTypeList';

const Message = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;
    function convertOrShow(variable) {
      if (variable) {
        if (typeof variable === 'object' && variable !== null) {
          return JSON.stringify(variable); // If the variable is an object, display it as a string
        } else {
          return variable.toString(); // If it's a primitive type, convert it to string
        }
      } else {
        return "Text message not found"; // If no content, show this fallback message
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: isBot ? '#eee' : '#eee', // Customize if needed
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              {convertOrShow(message?.content?.text)}
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    // Handle any potential errors in the component
    console.error(error);
    return 'Text message not found';
  }
};

const TextMessage = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const headerText = message?.content?.header?.text || "";
    const bodyText = message?.content?.body?.text || "No message content available";
    const footerText = message?.content?.footer?.text || '';

    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    return (
      <div
        style={{
          display: "flex",
          justifyContent: isBot ? "flex-start" : "flex-end",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            maxWidth: "400px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            backgroundColor: "#eee",
            padding: "15px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header Text */}
          {headerText && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              {headerText}
            </div>
          )}

          {/* Body Text */}
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              marginBottom: "15px",
              whiteSpace: "pre-wrap", // Preserve line breaks
            }}
          >
            {bodyText}
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
            }}
          >
            {footerText}
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            {!isBot ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:` : null} 
            {timestamp || ''}
            </div>
        </div>
      </div>
    );
  } catch (error) {
    return <div>Error displaying message</div>;
  }
};


const Message_type_button_reply = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';

    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;

    function convertOrShow(variable) {
      if (variable) {
        if (typeof variable === 'object' && variable !== null) {
          return JSON.stringify(variable);
        } else {
          return variable.toString();
        }
      } else {
        return "Text message not found"; // If no content, show fallback message
      }
    }
    const messageContent = message?.content?.text || message?.content?.button_reply || "Text message not found";

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: isBot ? '#eee' : '#eee', // Customize if needed
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            {/* Display message content */}
            <div style={{ marginBottom: '20px' }}>
              {convertOrShow(messageContent)}
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return 'Text message not found';
  }
};

const FlowMessage = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';

    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;

    function convertOrShow(variable) {
      if (typeof variable === 'object' && variable !== null) {
        return JSON.stringify(variable);
      } else {
        return variable.toString();
      }
    }

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: '#eee',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              {message?.content?.text || 'No content available'}
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch {
    return 'Error displaying message';
  }
};

const Message_Button = ({ message }) => {
  const isBot = message.origin === 'INBOUND';
  try {
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: isBot ? 'flex-start' : 'flex-end',
            marginBottom: '2px',
          }}
        >
          <Card
            style={{
              minWidth: 250,
              width: 275,
              maxWidth: 250,
              background: isBot
                ? '#eee'
                : '#fff',
              // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
              color: isBot ? '#000' : 'black',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              boxShadow: '3px 3px 6px #ccc',
            }}
          >
            <Card.Header>
              <span style={{ fontSize: '16px', lineHeight: '16px !important', fontWeight: '400' }}>
                {message?.content?.text}
              </span>
            </Card.Header>
            <Card.Text>
              <div style={{ textAlign: 'right', fontSize: '14px', color: 'grey' }}>
                {' '}
                <sub>
                  <span style={{ marginRight: '4px' }}>
                    {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
                  </span>
                  {timestamp || ''}
                  </sub>
              </div>
            </Card.Text>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                flexDirection: 'row',
              }}
            >
              {message &&
                message?.content?.options?.map((v, index) => (
                  // <div key={i} >
                  <button
                    style={{
                      background: 'white',
                      borderRadius: '5px',
                      margin: '2px',
                      width: '40%',
                      color: '#506fc7',
                      border: '1px solid #eee',
                    }}
                    key={index}
                  >
                    {v?.title}
                  </button>
                ))}
            </div>
          </Card>
        </div>
      </div>
    );
  } catch {
    return 'None';
  }
};

const MessageLocation = ({ message }) => {
  try {
    if (!message || !message.content) {
      return 'No message data available';
    }

    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    const { latitude, longitude } = message?.content?.location || {};
    const locationText = latitude && longitude ? `Location: ${latitude}, ${longitude}` : '';

    if (isBot) {
      const locationUrl = latitude && longitude ? `https://www.google.com/search?q=${latitude},${longitude}` : '';

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            marginBottom: '14px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: '10px',
              marginLeft: '5px',
              minWidth: '200px',
              boxShadow: '3px 3px 6px #ccc',
              color: '#000',
              background: '#eee',
              borderRadius: '12px',
              position: 'relative',
            }}
          >
            <div
              style={{
                marginBottom: '5px',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              <p style={{ margin: '0', textAlign: 'center' }}>View Location</p>
            </div>
            <div
              style={{
                marginBottom: '5px',
                textAlign: 'center',
              }}
            >
              {locationUrl ? (
                <a href={locationUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
                  {locationUrl}
                </a>
              ) : (
                'No location available'
              )}
            </div>
            <div
              style={{
                fontSize: '12px',
                color: '#555',
                textAlign: 'center',
              }}
            >
              {message?.content?.text || 'Send current location'}
            </div>
            <span style={{ position: 'absolute', bottom: '5px', right: '10px', fontSize: '11px', color: '#555' }}>
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp || ''}
            </span>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '14px',
          }}
        >
          <div
            style={{
              padding: '10px',
              marginLeft: '0px',
              marginRight: '5px',
              minHeight: '50px',
              minWidth: '150px',
              boxShadow: '3px 3px 6px #ccc',
              color: '#000',
              background: '#fff',
              borderRadius: '12px 12px 0px 12px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <div
              style={{
                marginBottom: '2px',
                fontWeight: 'bold',
                display: 'flex',
                justifyContent: 'flex-start',

              }}
            >
              <p style={{ margin: '0' }}>Location</p>
            </div>
            <p style={{ margin: '5px 0', textAlign: 'center' }}>
              {locationText || 'Send current location'}
            </p>
            <span style={{ position: 'absolute', bottom: '5px', right: '10px', fontSize: '11px', color: '#555' }}>
              <span style={{ marginRight: '4px' }}>
                {message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase()}
              </span>
              {timestamp}
            </span>
          </div>
        </div>
      );
    }
  } catch (error) {
    return 'Error rendering location';
  }
};

const Message_Image = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            variant="outlined"
            style={{
              padding: '5px 10px',
              marginLeft: isBot ? '5px' : '0px',
              marginRight: isBot ? '0px' : '5px',
              minHeight: '200px',
              minWidth: '150px',
              boxShadow: '3px 3px 6px #ccc',
              position: 'relative',
              color: isBot ? '#000' : 'black',
              background: isBot
                ? '#eee'
                : '#fff',
              // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
            }}
          >
            <Row>
              <Col>
                {/* Example image */}
                <Image
                  src={message?.content?.previewUrl || message?.content?.url}
                  style={{ width: '200px', height: '150px' }}
                />
              </Col>
            </Row>
            <span style={{ position: 'absolute', bottom: '5px', right: '10px', fontSize: '11px' }}>
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp}
            </span>
          </div>
        </div>
      </div>
    );
  } catch {
    return 'None';
  }
};

const MessageFile = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <Card
          style={{
            minWidth: 250,
            width: 275,
            maxWidth: 250,
            background: isBot
              ? '#eee'
              : '#fff',
            // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
            color: isBot ? '#000' : 'black',
            borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
            boxShadow: '3px 3px 6px #ccc',
          }}
        >
          <Card.Body
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '32%',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-file-earmark-pdf"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                  <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                </svg>
              </span>
              <p variant="dark">File</p>
            </div>
            <div>
              <a href={`${message?.content?.url}`} target="_blank" rel="noopener noreferrer">
                <span style={{ cursor: 'pointer', color: '#000' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                    />
                  </svg>
                </span>
              </a>
            </div>
          </Card.Body>
          <Card.Footer>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >

              <div>
                <p style={{ margin: '4px', display: 'inline' }} variant="dark">
                  1 Page |
                </p>
                <p style={{ margin: '4px', display: 'inline' }} variant="dark">
                  24 kb |
                </p>
                <p style={{ margin: '4px', display: 'inline' }} variant="dark">
                  PDF
                </p>
              </div>
              <div>
                <p variant="dark" style={{ fontSize: '13px' }}>
                  <span style={{ marginRight: '4px' }}>
                    {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
                  </span>
                  {timestamp || ''}
                  </p>
              </div>
            </div>
          </Card.Footer>
        </Card>
      </div>
    );
  } catch {
    return 'None';
  }
};

const MessageVideo = ({ message }) => {
  const isBot = message?.origin === 'INBOUND';
  try {
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            variant="outlined"
            style={{
              padding: '5px 10px',
              marginLeft: isBot ? '5px' : '0px',
              marginRight: isBot ? '0px' : '5px',
              minHeight: '200px',
              minWidth: '150px',
              boxShadow: '3px 3px 6px #ccc',
              position: 'relative',
              color: isBot ? '#000' : 'black',
              background: isBot
                ? '#eee'
                : '#fff',
              // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
            }}
          >
            <Row>
              <Col>
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe
                    className="embed-responsive-item"
                    src={message?.content?.url || ''}
                    title="Embedded Video"
                    allowFullScreen
                    style={{ width: 'auto', height: 'auto' }}
                  ></iframe>
                </div>
              </Col>
            </Row>

            <span style={{ position: 'absolute', bottom: '5px', right: '10px', fontSize: '11px' }}>
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp || ''}
            </span>
          </div>
        </div>
      </div>
    );
  } catch {
    return 'None';
  }
};

const MessageAudio = ({ message }) => {
  const isBot = message?.origin === 'INBOUND';
  try {
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            variant="outlined"
            style={{
              padding: '5px 10px',
              marginLeft: isBot ? '5px' : '0px',
              marginRight: isBot ? '0px' : '5px',
              minHeight: '120px',
              minWidth: '220px',
              boxShadow: '3px 3px 6px #ccc',
              position: 'relative',
              // color: isBot ? '#444' : 'white',
              color: isBot ? '#000' : 'black',
              background: isBot
                ? '#eee'
                : '#eee',
              // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
            }}
          >
            <Row>
              <Col>
                <audio controls style={{ width: '200px', height: '80px' }}>
                  <source src={message?.content?.url || ''} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </Col>
            </Row>
            <span style={{ position: 'absolute', bottom: '5px', right: '10px', fontSize: '11px' }}>
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp || ''}
            </span>
          </div>
        </div>
      </div>
    );
  } catch {
    return 'None';
  }
};


const MessageNfmReply = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;

    const nfmReply = message?.content?.nfm_reply;

    // Ensure nfmReply exists and is an object
    if (!nfmReply || typeof nfmReply !== 'object') {
      return 'Error in NFM reply';
    }

    // Dynamically extract and map nfmReply fields
    let displayFields;
    try {
      displayFields = Object.keys(nfmReply).map((key) => {
        const labelMap = {
          screen_0_RadioButtonsGroup_1: 'Role',
          screen_0_RadioButtonsGroup_2: 'Experience',
          screen_0_RadioButtonsGroup_3: 'Work Preference',
          screen_0_TextInput_0: 'Name',
          screen_0_TextArea_4: 'Comments',
        };
        return {
          key,
          label: labelMap[key] || key,
          value: typeof nfmReply[key] === 'object' ? JSON.stringify(nfmReply[key]) : nfmReply[key],
        };
      });
    } catch (error) {
      console.error('Error parsing nfmReply fields:', error);
      displayFields = [];
    }

    // Handle input_text.values if present
    let inputTextFields = [];
    try {
      const inputTextValues = message?.input_text?.values || {};
      inputTextFields = Object.entries(inputTextValues).map(([key, value]) => ({
        key,
        label: key.replace(/_/g, ' '),
        value: typeof value === 'object' ? JSON.stringify(value) : value,
      }));
    } catch (error) {
      console.error('Error parsing input_text values:', error);
    }

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: '#eee',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <div className="user-profile-inner">
              {displayFields.filter(({ key }) => key !== 'values').map(({ key, label, value }) => (
                value && (
                  <p style={{ marginBottom: '5px' }} key={key}>
                    {label}: <span>{value}</span>
                  </p>
                )
              ))}
              {inputTextFields.map(({ key, label, value }) => (
                value && (
                  <p style={{ marginBottom: '5px' }} key={key}>
                    {label}: <span>{value}</span>
                  </p>
                )
              ))}
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error in NFM reply rendering:', error);
    return 'Error in NFM reply';
  }
};


const MessageOrder = ({ message }) => {
  const isBot = message?.origin === 'INBOUND';

  try {
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;

    function convertOrShow(variable) {
      if (typeof variable === 'object' && variable !== null) {
        return JSON.stringify(variable, null, 2); // Pretty-print JSON
      } else {
        return variable.toString();
      }
    }

    // Extract order details
    const orderDetails = message?.content?.product_items || [];
    const totalAmount = orderDetails.reduce((sum, item) => sum + (item.item_price * item.quantity), 0);

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: isBot ? '#eee' : '#d1e7dd',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <h4>{isBot ? 'ORDER RECEIVED' : 'YOUR ORDER'}</h4>
            <div style={{ marginBottom: '10px' }}>
              {convertOrShow(message?.content?.text)}
            </div>
            <ul style={{ padding: 0, listStyle: 'none', margin: '0 0 20px' }}>
              {orderDetails.map((item, index) => (
                <li key={index}>
                  Product ID: {item.product_retailer_id}, Quantity: {item.quantity}, Price: {item.item_price} {item.currency}
                </li>
              ))}
            </ul>
            <div>
              <strong>Total Amount: {totalAmount} INR</strong>
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return <span>Error displaying order message</span>;
  }
};



const MessageCatalog = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;

    function convertOrShow(variable) {
      if (typeof variable === 'object' && variable !== null) {
        return JSON.stringify(variable);
      } else {
        return variable?.toString() || '';
      }
    }

    const catalogContent = message?.content || {};
    const catalogHeader = catalogContent?.header?.text || '';
    const catalogBody = catalogContent?.body?.text || '';
    const catalogFooter = catalogContent?.footer?.text || '';
    const actionId = catalogContent?.action?.thumbnail_product_retailer_id || '';

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: '#eee',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <h5>Catalog</h5>
            {catalogHeader && <p><strong>{convertOrShow(catalogHeader)}</strong></p>}
            {catalogBody && <p>{convertOrShow(catalogBody)}</p>}
            {catalogFooter && <p><i>{convertOrShow(catalogFooter)}</i></p>}
            {actionId && <p>Product ID: {convertOrShow(actionId)}</p>}
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return 'Error displaying catalog message';
  }
};


const MessageDefault = ({ message }) => {
  const isBot = message?.origin === 'INBOUND';
  try {
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',

        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',

          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: isBot
                ? '#eee'
                : '#eee',
              // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <div style={{ marginBottom: '20px' }}>{JSON.stringify(message?.content || "Message type not found")}</div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0)?.toUpperCase() + message?.status?.type?.slice(1)?.toLowerCase() : null}
              </span>
              {timestamp || ''}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch (error) {
    return <span>{error}</span>;
  }
};

const MessagePayment = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
    const minWidth = `${Math.max(250, timestamp.length * 7)}px`;
    const displayData = message?.content?.text;

    // Ensure nfmReply exists and is an object
    if (!displayData && typeof displayData !== 'object') {
      return 'Message not found';
    }


    return (
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isBot ? 'row' : 'row-reverse',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              padding: '10px 45px 10px 15px',
              marginLeft: isBot ? 1 : 0,
              maxWidth: '250px',
              minWidth: minWidth,
              position: 'relative',
              marginRight: isBot ? 0 : 1,
              color: isBot ? '#000000' : 'black',
              boxShadow: '3px 3px 6px #ccc',
              background: '#eee',
              borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
              wordBreak: 'break-word',
            }}
          >
            <div className="user-profile-inner">
              {Object.entries(displayData)?.map(([key, value]) => {
                return (
                  <p style={{ marginBottom: '5px' }} key={key}>
                    {key}:  <span>{value?.toString()}</span>
                  </p>
                )
              })}
            </div>
            <sub
              style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
              }}
            >
              <span style={{ marginRight: '4px' }}>
                {!isBot ? message?.status?.type?.charAt(0).toUpperCase() + message?.status?.type?.slice(1).toLowerCase() : null}
              </span>
              {timestamp}
            </sub>
          </div>
        </div>
      </div>
    );
  } catch {
    return 'Error in payment message';
  }
}

const MessageButtons = ({ message }) => {
  try {
    // Check if it's an outbound message (Bot message)
    const isBot = message?.origin === "INBOUND";

    // Extract required data from the message object
    const headerText = message?.content?.header?.text || '';
   const bodyText = message?.content?.body || message?.content?.text || '';
   const listOptions = message?.content?.items?.[0]?.options || [];
    // const timestamp = new Date(message?.created_at).toLocaleString("en-IN", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    // });
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');


    return (
      <div
        style={{
          display: "flex",
          justifyContent: isBot ? "flex-start" : "flex-end",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            maxWidth: "350px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            backgroundColor: "#fff",
            padding: "15px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header Text */}
          {headerText && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              {headerText}
            </div>
          )}

          {/* Body Text */}
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              marginBottom: "15px",
              whiteSpace: "pre-wrap", // Preserve line breaks
            }}
          >
            {bodyText}
          </div>

          {/* Buttons */}
          {buttons.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {buttons.map((button, index) => (
                <button
                  key={index}
                  style={{
                    background: "white",
                    borderRadius: "5px",
                    padding: "10px",
                    fontSize: "14px",
                    borderRadius: "20px",
                    fontWeight: "bold",
                    color: "#506fc7",
                    border: "1px solid #eee",
                    cursor: "pointer",
                  }}
                >
                  {button.label}
                </button>
              ))}
            </div>
          )}

          {/* Footer */}
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            {!isBot ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:` : null} {timestamp}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error("Error rendering MessageButtons component:", error);
    return <div>Error displaying message</div>;
  }
};

const MessageList = ({ message }) => {
  const [showOptions, setShowOptions] = useState(false);
  const isBot = message?.origin === 'INBOUND';
  // Extract data from the message object
  const headerText = message?.content?.header?.text || "";
  const bodyText = message?.content?.body?.text || "";
  const listOptions = message?.content?.list[0]?.options || [];
  const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');
  // const timestamp = new Date(message?.created_at).toLocaleString("en-IN", {
  //   day: "2-digit",
  //   month: "2-digit",
  //   year: "numeric",
  //   hour: "2-digit",
  //   minute: "2-digit",
  // });

  const toggleOptions = () => {
    setShowOptions((prevState) => !prevState);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: isBot ? "flex-start" : "flex-end",
        marginBottom: "14px",
      }}
    >
      <div
        style={{
          maxWidth: "350px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
          backgroundColor: "#fff",
          padding: "15px",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Header */}
        {headerText && (
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "10px",
            }}
          >
            {headerText}
          </div>
        )}

        {/* Body */}
        <div
          style={{
            fontSize: "14px",
            lineHeight: "1.5",
            marginBottom: "15px",
          }}
        >
          {bodyText}
        </div>

        {/* View/Hide List Button */}
        <button
          onClick={toggleOptions}
          style={{
            background: "white",
            color: "#506fc7",
            border: "1px solid #eee",
            borderRadius: "20px",
            padding: "10px",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span>📋 {showOptions ? "Hide List" : "View List"}</span>
        </button>

        {/* List Options */}
        {showOptions && (
          <div
            style={{
              marginTop: "15px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {listOptions.map((option, index) => (
              <button
                key={index}
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "10px",
                  fontSize: "14px",
                  cursor: "pointer",
                  textAlign: "left",
                  color: "#333",
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}

        {/* Timestamp */}
        <div
          style={{
            fontSize: "12px",
            color: "#888",
            marginTop: "10px",
            textAlign: "right",
          }}
        >
          {!isBot ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:` : null} {timestamp}
        </div>
      </div>
    </div>
  );
};

const MessageWithDocument = ({ message }) => {
  try {
    const isBot = message?.origin === 'INBOUND';

    // Extract header and body
    const headerText = message?.content?.header?.text || "";
    const bodyText = message?.content?.body?.text || "No message content available";

    // Support both media and direct content
    const document = message?.content?.media || message?.content || {};
    const fileName = document?.filename || document?.s3_object?.filename || "Document";
    const fileSize = document?.file_size ? `${(document.file_size / 1024).toFixed(2)} KB` : "Unknown size";
    const mimeType = document?.mime_type || "Unknown type";

    const timestamp = dateFormate(
      indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp),
      'DD-MM-YYYY h:mm A'
    );

    return (
      <div
        style={{
          display: "flex",
          justifyContent: isBot ? "flex-start" : "flex-end",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            maxWidth: "400px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            backgroundColor: "#fff",
            padding: "15px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header */}
          {headerText && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              {headerText}
            </div>
          )}

          {/* Body */}
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              marginBottom: "15px",
              whiteSpace: "pre-wrap",
            }}
          >
            {bodyText}
          </div>

          {/* Document Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              background: "#f9f9f9",
              padding: "10px",
              borderRadius: "8px",
            }}
          >
            <div style={{ fontSize: "14px", fontWeight: "bold" }}>Document:</div>

            {document?.url ? (
              <a
                href={document.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "#506fc7",
                  fontWeight: "bold",
                }}
              >
                {fileName}
              </a>
            ) : (
              <div style={{ fontSize: "13px", color: "#999" }}>
                File is not available for download.
              </div>
            )}

            <div style={{ fontSize: "12px", color: "#888" }}>
              File Size: {fileSize}
            </div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              Type: {mimeType}
            </div>
          </div>

          {/* Additional Meta Info */}
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              marginTop: "10px",
              lineHeight: "1.4",
            }}
          >
            <div><strong>WhatsApp Name:</strong> {message?.whatsapp_name || "N/A"}</div>
            <div><strong>Phone Number:</strong> {message?.phone_number || "N/A"}</div>
            <div><strong>Bot Number:</strong> {message?.bot_number || "N/A"}</div>
            <div><strong>Company ID:</strong> {message?.company_id || "N/A"}</div>
            <div><strong>Message ID:</strong> {message?.msg_id || "N/A"}</div>
          </div>

          {/* Footer Timestamp */}
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            {!isBot
              ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:`
              : null}{" "}
            {timestamp}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error("Error rendering MessageWithDocument component:", error);
    return <div>Error displaying message</div>;
  }
};


const MessageWithVideo = ({ message }) => {
  try {
    // Check if it's an outbound message (Bot message)
    const isBot = message?.origin === "INBOUND";

    // Extract required data from the message object
    const headerText = message?.content?.header?.text || "";
    const bodyText = message?.content?.body?.text || "No message content available";
    const video = message?.content?.media || {};
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    // const timestamp = new Date(message?.created_at).toLocaleString("en-IN", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    // });

    return (
      <div
        style={{
          display: "flex",
          justifyContent: isBot ? "flex-start" : "flex-end",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            maxWidth: "400px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            backgroundColor: "#eee",
            padding: "15px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header Text */}
          {headerText && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              {headerText}
            </div>
          )}

          {/* Body Text */}
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              marginBottom: "15px",
              whiteSpace: "pre-wrap", // Preserve line breaks
            }}
          >
            {bodyText}
          </div>

          {/* Video Section */}
          {video?.url && (
            <div style={{ marginBottom: "10px" }}>
              <video
                controls
                style={{
                  width: "100%",
                  borderRadius: "8px",
                }}
              >
                <source src={video.url} type={video.mime_type} />
                Your browser does not support the video tag.
              </video>
              <div style={{ fontSize: "12px", color: "#888", marginTop: "5px" }}>
                File Size: {(video.file_size / (1024 * 1024)).toFixed(2)} MB
              </div>
            </div>
          )}

          {/* Footer */}
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            {!isBot ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:` : null} {timestamp}

          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error("Error rendering MessageWithVideo component:", error);
    return <div>Error displaying message</div>;
  }
};

const MessageWithAudio = ({ message }) => {
  try {
    // Check if it's an outbound message (Bot message)
    const isBot = message?.origin === "INBOUND";

    // Extract required data from the message object
    const headerText = message?.content?.header?.text || "";
    const bodyText = message?.content?.body?.text || "No message content available";
    const audio = message?.content?.media || {};
    const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

    // const timestamp = new Date(message?.created_at).toLocaleString("en-IN", {
    //   day: "2-digit",
    //   month: "2-digit",
    //   year: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    // });

    return (
      <div
        style={{
          display: "flex",
          justifyContent: isBot ? "flex-start" : "flex-end",
          marginBottom: "14px",
        }}
      >
        <div
          style={{
            maxWidth: "400px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "12px",
            backgroundColor: "#eee",
            padding: "15px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          {/* Header Text */}
          {headerText && (
            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "10px",
              }}
            >
              {headerText}
            </div>
          )}

          {/* Body Text */}
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              marginBottom: "15px",
              whiteSpace: "pre-wrap", // Preserve line breaks
            }}
          >
            {bodyText}
          </div>

          {/* Audio Section */}
          {audio?.url && (
            <div style={{ marginBottom: "10px" }}>
              <audio
                controls
                style={{
                  width: "100%",
                  borderRadius: "8px",
                }}
              >
                <source src={audio.url} type={audio.mime_type} />
                Your browser does not support the audio tag.
              </audio>
              <div style={{ fontSize: "12px", color: "#888", marginTop: "5px" }}>
                File Size: {(audio.file_size / (1024 * 1024)).toFixed(2)} MB
              </div>
            </div>
          )}

          {/* Footer */}
          <div
            style={{
              fontSize: "12px",
              color: "#888",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            {!isBot ? `${message?.status?.type?.charAt(0)?.toUpperCase()}${message?.status?.type?.slice(1)?.toLowerCase()}:` : null} {timestamp}
          </div>
        </div>
      </div>
    );
  } catch (error) {
    console.error("Error rendering MessageWithAudio component:", error);
    return <div>Error displaying message</div>;
  }
};

function MessageNode({ message }) {
  const type = message?.content?.type;
  try {
    switch (type) {
      case 'text':
      case 'flow':
      // case 'button_reply':
      case 'order_details':
      case 'list_reply':
      case 'address':
        return <Message message={message} />;
      case "TEXT":
        return <TextMessage message={message} />;
      case 'button_reply':
        return <Message_type_button_reply message={message} />;
      case 'file':
        return <MessageFile message={message} />;
      case "BUTTONS":
        return <MessageButtons message={message} />;
      case 'image':
        return <Message_Image message={message} />;
      case 'Flow':
        return <FlowMessage message={message} />;
      case 'list':
        return <MessageTypeList message={message} />;
      case "LIST":
        if (message?.origin === "INBOUND") {
          return <MessageTypeList message={message} />;
        } else if (message?.origin === "OUTBOUND") {
          return <MessageList message={message} />;
        }
      case "DOCUMENT":
      case "document" :
        if (message?.origin === "INBOUND") {
          return <MessageFile message={message} />;
        } else if (message?.origin === "OUTBOUND") {
          return <MessageWithDocument message={message} />;
        }
      case "VIDEO":
        if (message?.origin === "INBOUND") {
          return <MessageVideo message={message} />;
        } else if (message?.origin === "OUTBOUND") {
          return <MessageWithVideo message={message} />;
        }
      case "AUDIO":
        if (message?.origin === "INBOUND") {
          return <MessageAudio message={message} />;
        } else if (message?.origin === "OUTBOUND") {
          return <MessageWithAudio message={message} />;
        }
      case 'quick_reply':
        return <Message_Button message={message} />;
      case 'video':
        return <MessageVideo message={message} />;
      case 'audio':
        return <MessageAudio message={message} />;
      case 'nfm_reply':
        return <MessageNfmReply message={message} />;
      case 'order':
      case 'ORDER' :
        return <MessageOrder message={message} />;
      case 'catalog_message':
      case 'catelog':
      case 'CATALOG' :
        return <MessageCatalog message={message} />;
      case 'location':
        return <MessageLocation message={message} />;
      case 'payment':
        return <MessagePayment message={message} />
      default:
        return <MessageDefault message={message} />;
    }
  } catch (error) {
    return <span>Error</span>;
  }

}


export default MessageNode;
